var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"bottom-margin-30"},[_c('ThanksPageTitle',{attrs:{"title":_vm.i18nItems.contentsInfo[_vm.contents].title}})],1),_c('EmailMessenger',{attrs:{"page":this.fromPageInfo.page}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }